import { localCache } from "@/utils/Cache";

export function hasLimits(str) {
  let hasPermission = false;
  if (localCache.getCache("permissionList")?.length) {
    let permission = JSON.parse(localCache.getCache("permissionList"));
    const state = permission.includes(str);
    if (state) {
      hasPermission = true;
    } else {
      hasPermission = false;
    }
    return hasPermission;
  }
}
